<div *ngIf="amdinNstate?.admin && !route.snapshot.params.state"
    class="m-portlet portlet-batches-notranslate table table-overflow">
    <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text m--font-info">
                    Form Section Review
                </h3>
            </div>
        </div>
    </div>
    <div class="m-portlet__body body-padding">
        <div class="m_datatable m-datatable m-datatable--default">
            <form class="m-form m-form--fit m-form--label-align-right" id="m_form_1" novalidate="novalidate"
                [formGroup]="reviewCommentsForForm">
                <div class="m-portlet__body">
                    <div class="form-group m-form__group row">
                        <div class="col-lg-3 m-form__group-sub">
                            <label class="form-control-label">Review Comments <span class="mandatory">*</span></label>
                        </div>
                        <div class="col-lg-9 m-form__group-sub">
                            <select class="form-control m-input" (change)="formInputValidationReview()"
                                formControlName="review">
                                <option value="" disabled selected>Select your Review</option>
                                <option value="approved">Approved</option>
                                <option value="Not Approved">Not-Approved</option>
                            </select>
                            <app-form-control-messages [control]="reviewCommentsForForm.get('review')"
                                [name]="'Review Comments'">
                            </app-form-control-messages>
                            <br>
                            <textarea class="form-control m-input" formControlName="comment"></textarea>
                            <app-form-control-messages [control]="reviewCommentsForForm.get('comment')"
                                [name]="'Comments'">
                            </app-form-control-messages>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<div class="m-portlet m-portlet--mobile">
    <div *ngIf="!amdinNstate?.admin" class="m-portlet__head">
        <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text">
                    <h4>Training Centre ID {{route.snapshot.params.tcId}}:</h4>
                </h3>
                <span class="form_head_title right">
                    <button class="btn btn-with-border" (click)="back()">Back</button>
                </span>
            </div>
        </div>
    </div>
    <div class="m-portlet__body">
        <!--begin: Search Form -->
        <div *ngIf="!amdinNstate?.admin" class="declaration-payment">
            <!-- <div class="image-div">
              <img src="../../../assets/images/TrainingCenterMobile.png">
          </div> -->
            <p class="first-text">For the next step in the add/modify training centre form, you need to install the
                <span class="m--font-info"><b>Training Centre Photo Upload Mobile Application</b></span> on your Android
                Phone to Upload the photos as proof for the details
                required.</p>
            <div class="mobile-number-div">
                <p class="middle-text">If you do not remember your password or to create a new password, click on
                    ‘regenerate password.</p>
                <form [formGroup]="mobileForm" class="m-form m-form--fit m-form--label m-form--label-align-right">
                    <div class="form-group m-form__group row">
                        <label for="" class="col-1 col-form-label tc-text-align">
                            Email
                        </label>
                        <div class="col-3">
                            <input disabled class="form-control m-input" type="text" formControlName="email"
                                placeholder="Enter Email">
                        </div>
                        <label for="" class="col-1 col-form-label tc-text-align">
                            Mobile Number
                        </label>
                        <div class="col-3">
                            <input disabled class="form-control m-input" type="text" formControlName="mobileNumber"
                                placeholder="Enter Mobile Number">
                        </div>
                        <div class="col-lg-2 get-mobile-link">
                            <a class="m--font-info" (click)="getMobileAppLink()"><b>Regenerate Password</b></a>
                        </div>
                    </div>
                </form>
                <p class="last-text">As soon as the photos are uploaded successfully you will be able to review and
                    submit the Training Centre form here.</p>
            </div>
        </div>
        <hr>

        <form *ngIf="showData && !isSchemeIdGrameenUdhyami; else uploadPhotos" class="m-form m-form--fit m-form--label-align-right" id="m_form_1"
            novalidate="novalidate" [formGroup]="reviewCommentsForm">
            <h3>Facilities available at Training Centre : </h3>
            <div class="m-portlet__body">
                <div formArrayName="reviews"
                    *ngFor="let item of reviewCommentsForm.get('reviews').controls; let i = index;">
                    <ng-container>
                        <div *ngFor="let p of objectKeys(photosAsArray[i])" class="form-group m-form__group row">
                            <div class="col-lg-12 m-form__group-sub">
                                <br>
                                <h3>{{getProperText(p)}}</h3>
                            </div>
                            <div *ngFor="let img of photosAsArray[i][p]; let cap = index" class="col-4">
                                <figure class="image-alignment">
                                    <img target="_blank" rel="noopener" src="{{img.imgURL}}" (click)="getFile(img)"
                                        class="img-thumbnail img-height" alt="No Image Found" style="width:40%">
                                    <figcaption>{{getProperTextFigCaption(p) + ' ' + (cap + 1)}}</figcaption>
                                </figure>
                            </div>
                        </div>
                    </ng-container>
                    <div [formGroupName]="i">
                        <div *ngIf="(showReviewsInTp || amdinNstate?.admin) && (!route.snapshot.params.state)"
                            class="form-group m-form__group row">
                            <div class="col-lg-3 m-form__group-sub">
                                <label class="form-control-label">Review Comments <span
                                        class="mandatory">*</span></label>
                            </div>
                            <div class="col-lg-9 m-form__group-sub">
                                <select class="form-control m-input" (change)="commentsValidation(i, $event, false)"
                                    formControlName="review">
                                    <option value="" disabled selected>Select your Review</option>
                                    <option value="approved">Verified</option>
                                    <option value="Document Required">Not-Verified</option>
                                </select>
                                <app-form-control-messages
                                    [control]="reviewCommentsForm['controls'].reviews.controls[i].controls.review"
                                    [name]="'Review Comments'"></app-form-control-messages>
                                <br>
                                <textarea class="form-control m-input" (blur)="commentsValidation(i, $event, comment)"
                                    (paste)="commentsValidation(i, $event, comment)"
                                    (keydown)="commentsValidation(i, $event, comment)"
                                    formControlName="comment"></textarea>
                                <p class="mandatory" *ngIf="commentsValidationArray[i] === true">Comments is required
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <ng-template #uploadPhotos>
            <h3 *ngIf="!amdinNstate?.admin">Upload photos through mobile application link </h3>
        </ng-template>
        <br>
        <div *ngIf="!route.snapshot.params.state" class="btn-div col-12">
            <hr>
            <button class="btn btn-info blue-btn"
                *ngIf="!showData && !amdinNstate?.admin || (!isCountOfphotosAndcountOfPhotosExitSame && !amdinNstate?.admin)"
                (click)="getTc()">Save &
                Next</button>
            <button class="btn btn-info blue-btn"
                *ngIf="showData && !amdinNstate.admin && isCountOfphotosAndcountOfPhotosExitSame"
                (click)="submitForApproval()">Submit</button>
            <button class="btn btn-secondary" *ngIf="amdinNstate?.admin" (click)="getUpdatedValue()">Submit
                Reviews</button>
            <button class="btn btn-secondary" (click)="back()">Cancel</button>
            <!-- <app-display-result *ngIf="sweetAlert" [message]="sweetAlert" (responseMessage)="responseMessageFromAlert($event)"></app-display-result> -->
        </div>
        <!--end: Datatable -->
    </div>


    <div class="modal fade" id="preview_img" tabindex="-1" role="dialog" aria-labelledby="viewSessionDetails">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <!-- <h5 class="modal-title" id="viewSessionDetails" style="font-weight: bold">Name</h5> -->
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="m-card-profile__pic-wrapper" style="margin: auto;text-align: center;">
                        <img class="modal-image" [src]="modalImage" width="100%" alt="">
                    </div>
                    <span>
                        <dl class="row">
                            <dt class="col-sm-3">TC ID:</dt>
                            <dd class="col-sm-3">{{route.snapshot.params.tcId}}</dd>
                            <dt class="col-sm-3">TP ID:</dt>
                            <dd class="col-sm-3">
                                {{tcData && tcData.trainingPartner ? tcData.trainingPartner.userName : '--'}}</dd>
                            <dt class="col-sm-3">Lattitude:</dt>
                            <dd class="col-sm-3">{{prevImg && prevImg.latitude ? prevImg.latitude : '--'}}</dd>
                            <dt class="col-sm-3">Longitude:</dt>
                            <dd class="col-sm-3">{{prevImg && prevImg.longitude ? prevImg.longitude : '--'}}</dd>
                            <dt class="col-sm-3">Captured On:</dt>
                            <dd class="col-sm-3">
                                {{prevImg && prevImg.pictime ? (prevImg.pictime | date: 'dd/MM/yyyy HH:mm:ss') : '--'}}
                            </dd>
                        </dl>
                    </span>
                </div>
                <div class="modal-footer default">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>